import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PageResponse} from '../../../shared/commons/page-response';

export interface SubCbDto {
  id?: number;
  title?: string;
  departmentId?: number;
  departmentNameTh?: string;
  taxid?: string;
  refId?: string;
  address?: string;
  province?: number;
  district?: number;
  subdistrict?: number;
  zipcode?: string;
  telephone?: string;
  fax?: string;
  lat?: string;
  lng?: string;
  ordering?: number;
  state?: number;
  createdBy?: number;
  createdDate?: string;
  modifiedBy?: number;
  modifiedDate?: string;
  attach?: string;
}

@Injectable({providedIn: 'root'})
export class SubCbService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/master/sub-cbs';

  search(params: HttpParams): Observable<PageResponse<SubCbDto>> {
    return this.http.get<PageResponse<SubCbDto>>(this.apiUrl, {params});
  }

  getActiveSubCbs(): Observable<SubCbDto[]> {
    return this.http.get<SubCbDto[]>(`${this.apiUrl}/active`);
  }

  getSubCbById(id: number): Observable<SubCbDto> {
    return this.http.get<SubCbDto>(`${this.apiUrl}/${id}`);
  }

  createSubCb(subcb: SubCbDto): Observable<SubCbDto> {
    return this.http.post<SubCbDto>(this.apiUrl, subcb);
  }

  updateSubCb(id: number, subcb: SubCbDto): Observable<SubCbDto> {
    return this.http.put<SubCbDto>(`${this.apiUrl}/${id}`, subcb);
  }

  deleteSubCb(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
